import { isValidPhoneNumber } from 'libphonenumber-js';

export const phoneNumberValidation = {
  name: 'phoneNumber',
  exclusive: true,
  message: 'Numéro de téléphone invalide',
  test: (value: string | undefined) => {
    if (!value) return true;
    try {
      return isValidPhoneNumber(value, 'FR');
    } catch {
      return false;
    }
  },
};
